/**
 * Detect text direction based on first strong directional character (bidi algorithm).
 * Used to determine RTL vs LTR rendering for emails and UI elements.
 *
 * @param text - The text to analyze
 * @returns 'rtl' if the first strong character is RTL (Arabic, Hebrew, etc.), 'ltr' otherwise
 */
export function detectDirection(text: string): 'rtl' | 'ltr' {
  // RTL Unicode ranges: Hebrew, Arabic, Syriac, Thaana, NKo, Samaritan, Mandaic, Arabic Extended, etc.
  const rtlRegex = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  // LTR Unicode ranges: Basic Latin, Latin Extended, etc.
  const ltrRegex = /[A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8]/;

  for (const char of text) {
    if (rtlRegex.test(char)) return 'rtl';
    if (ltrRegex.test(char)) return 'ltr';
  }
  return 'ltr';
}
